const fields = (t) => ({
    config: {columns: 1},
    fields: [
        {
            name: "packingLine",
            label: t ? t("common.packing_line") : "Linia pakująca",
            column: 1,
            type: "dictionary",
            dictionary: "packingLine",
            dictionaryApi: "line",
        },
        {
            name: "nameAndDose",
            label: t ? t("common.name_and_dose") : "Nazwa i dawka",
            column: 1
        },
        {
            name: "packingSystem",
            label: t ? t("common.packing_system") : "System pakowania",
            column: 1,
            type: "enum",
            enumType: "enums/packingSystem"
        },
        {
            name: "tabletType",
            label: t ? t("common.capsule_or_tablet") : "Kapsułka lub tabletka",
            column: 1,
            type: "enum",
            enumType: "enums/capsuleOrTablet",
        },
        {
            name: "capsuleSize",
            label: t ? t("common.capsule_size") : "Rozmiar kapsułki",
            column: 1,
            type: "dictionary",
            dictionary: "capsuleSize",
            conditionalOn: "tabletType",
            conditionalOnMatchValue: "CAPSULE"
        },
        {
            name: "tabletShape",
            label: t ? t("common.tablet_shape") : "Kształt tabletki",
            column: 1,
            type: "text",
            conditionalOn: "tabletType",
            conditionalOnMatchValue: "TABLET"
        },
        {
            name: "comments",
            label: t ? t("common.comments") : "Uwagi",
            column: 1,
            type: "textarea"
        },
        {
            name: "machineTypes",
            label: t ? t("common.machine_types_for_config") : "Typy maszyn do konfiguracji",
            column: 1,
            type: "enum",
            mandatory: true,
            enumType: "enums/machineType",
            multiple: true
        },
        {
            name: "moveComment",
            label: t ? t("common.production_handover_comment") : "Komentarz przekazania do produkcji",
            column: 1,
            type: "textarea",
            onlyForReadOnly:true
        },

    ]
});

export default fields;
